/* eslint-disable react/destructuring-assignment */
import React from 'react';

import {connect} from 'react-redux';

import CycleGraph2 from '@/assets/icons/CycleGraph2.svg';
import CycleInfo2 from '@/assets/icons/CycleInfo2.svg';
import CycleSetup2 from '@/assets/icons/CycleSetup2.svg';
import PressureIcon from '@/assets/icons/SystemSettingsPressure.svg';
import * as APPDATA from '@/constants/pcConstAppData';
import {GetPathOfPage} from '@/libs/appHelper';

import BottomMenuCommon from '../../menu/bottommenu/BottomMenuCommon';

import StatusProgressBar from './StatusProgress';

import './AutoProfile.scss';

@connect((store) => ({
  isScheduleWillRun: store.schedulerState.isScheduleWillRun,
}))
export default class AutoProfilePageMenu extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      activeMenu: undefined,
    };
  }

  componentDidMount() {
    const activePageAddress = GetPathOfPage(window.location.href);
    let activeMenu;
    switch (activePageAddress) {
      case APPDATA.AUTO_PROFILE_SETUP:
        activeMenu = APPDATA.AUTO_PROFILE_MENU.SETUP;
        break;
      case APPDATA.AUTO_PROFILE_STATUS:
        activeMenu = APPDATA.AUTO_PROFILE_MENU.STATUS;
        break;
      case APPDATA.VOLUME_SENSOR_CHART_ADDRESS:
        activeMenu = APPDATA.AUTO_PROFILE_MENU.GRAPH;
        break;
      case APPDATA.AUTO_PROFILE_PARAMETERS:
        activeMenu = APPDATA.AUTO_PROFILE_MENU.PARAMETERS;
        break;
      default:
        break;
    }

    this.setState({
      activeMenu,
    });
  }

  // eslint-disable-next-line class-methods-use-this
  onClick = (e) => {
    switch (e.currentTarget.id) {
      case APPDATA.AUTO_PROFILE_MENU.SETUP:
        window.location.href = APPDATA.AUTO_PROFILE_SETUP;
        break;
      case APPDATA.AUTO_PROFILE_MENU.STATUS:
        window.location.href = APPDATA.AUTO_PROFILE_STATUS;
        break;
      case APPDATA.AUTO_PROFILE_MENU.PARAMETERS:
        window.location.href = APPDATA.AUTO_PROFILE_PARAMETERS;
        break;
      default:
        window.location.href = APPDATA.VOLUME_SENSOR_CHART_ADDRESS;
        break;
    }
  };

  render() {
    const {activeMenu} = this.state;
    // eslint-disable-next-line react/prop-types
    const {isScheduleWillRun} = this.props;

    const buttonMenuParam = {
      activeId: activeMenu,
      buttonProps: [
        {
          id: APPDATA.AUTO_PROFILE_MENU.SETUP,
          label: APPDATA.AUTO_PROFILE_MENU.SETUP,
          onClick: this.onClick,
          icon: CycleSetup2,
          disabled: isScheduleWillRun,
        },
        {
          id: APPDATA.AUTO_PROFILE_MENU.STATUS,
          label: APPDATA.AUTO_PROFILE_MENU.STATUS,
          onClick: this.onClick,
          icon: CycleInfo2,
          disabled: isScheduleWillRun,
        },
        {
          id: APPDATA.AUTO_PROFILE_MENU.GRAPH,
          label: APPDATA.AUTO_PROFILE_MENU.GRAPH,
          onClick: this.onClick,
          icon: CycleGraph2,
          disabled: isScheduleWillRun,
        },
        {
          id: APPDATA.AUTO_PROFILE_MENU.PARAMETERS,
          label: APPDATA.AUTO_PROFILE_MENU.PARAMETERS,
          onClick: this.onClick,
          icon: PressureIcon,
          disabled: isScheduleWillRun,
        },
      ],
    };

    return (
      <>
        <BottomMenuCommon buttonParam={buttonMenuParam} />
        <div className="autoProfileStatus">
          <StatusProgressBar />
        </div>
      </>
    );
  }
}
